export const formatDDMMYYYY = (dateString) => {
  if (!dateString) return "-";

  // Timezone-safe: avoid Date() shifting
  const [datePart] = dateString.split("T");
  const [year, month, day] = datePart.split("-");

  if (!year || !month || !day) return "-";

  return `${day}/${month}/${year}`;
};
